// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PROFILE_WAS_SAVED = "Profil bol ulo\u017een\u00fd.";
